import * as React from "react";
import { Box, Typography, Divider, Link, useMediaQuery } from "@mui/material";
import logo from '../../assets/icons/logo.png';
import email from '../../assets/icons/email.png';
import phone from '../../assets/icons/phone.png';
import locationIcon from '../../assets/icons/location.png';
import clock from '../../assets/icons/clock.png';
import facebookIcon from '../../assets/icons/facebookIcon.png';
import theme from '../../theme';

const address =
  "အဆောင်(၉၄)၊အခန်း (၁၃) ပုလဲလမ်း၊စော်ဘွားကြီးကုန်း ပွဲရုံဝင်း၊အင်းစိန်မြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး";
const mandalayAddress =
  "အမှတ် ၁၀၈ ၊ ၂၅ လမ်း ၊ ၈၃ လမ်းနှင့် ၈၄ လမ်းကြား ၊ မန္တလေးမြို့။";
const contactNumbers = [
  { value: "09677677552", display: "09 677 677 552" },
  { value: "09977257228", display: "09 977 257 228" },
];
const viberNumbers = [{ value: "09677677552", display: "09 677 677 552" }];
const mandalayContactNumbers = [
  { value: "09678782020", display: "09 678782020" },
  { value: "09788788539", display: "09788788539" },
  { value: "09404040677", display: "09404040677" },
];
const mandalayViberNumbers = [
  { value: "09678782020", display: "09 678782020" },
  { value: "09788788539", display: "09788788539" },
];

export function ContactInfo() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section>
      <Box sx={{ textAlign: 'justify', marginLeft: isMobile ? '20px' : '40px', display: 'flex', gap: 2 }}>
        <img src={logo} alt="MasterBladeMM logo" style={{ width: 180, objectFit: 'contain' }} />
        <Typography variant="h6" sx={{ alignSelf: 'center', fontFamily: "Amiko" }}>
          MasterBladeMM
        </Typography>
      </Box>

      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: isMobile ? '14px' : '16px', marginLeft: isMobile ? 0 : 2 }}>
          Connect With Us
        </Typography>
      </Box>
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px', display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', fontFamily: 'Roboto, sans-serif' }}>
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2">{address}</Typography>
            <Link
              href="https://maps.app.goo.gl/rxL8er7ph4KXxEzW9"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none', color: 'inherit' }}
            >
              Map Link
            </Link>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={clock} alt="Clock icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">ဖွင့်ချိန် မနက် ၉ နာရီ - ပိတ်ချိန် ညနေ ၆ နာရီ</Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Contact Numbers:{" "}
            {contactNumbers.map((number, index) => (
              <React.Fragment key={number.value}>
                <Link href={`tel:${number.value}`} sx={{ textDecoration: 'none', color: 'inherit' }}>
                  {number.display}
                </Link>
                {index < contactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Viber:{" "}
            {viberNumbers.map((number, index) => (
              <React.Fragment key={number.value}>
                <Link href={`viber://chat?number=${number.value}`} sx={{ textDecoration: 'none', color: 'inherit' }}>
                  {number.display}
                </Link>
                {index < viberNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={facebookIcon} alt="Facebook icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link
            href="https://www.facebook.com/share/1N5jqAVVFu/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            facebook.com/share/1N5jqAVVFu
          </Link>
        </Box>

        <Divider sx={{ mt: 1, mb: 1, ml: 2, mr: 2 }} />

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', fontFamily: 'Roboto, sans-serif' }}>
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2">{mandalayAddress}</Typography>
            <Link
              href="https://www.google.com/maps/place/21%C2%B059'05.0%22N+96%C2%B004'41.4%22E/@21.984726,96.07817,17z/data=!3m1!4b1!4m4!3m3!8m2!3d21.984726!4d96.07817!17m2!4m1!1e3!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDIwMS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none', color: 'inherit' }}
            >
              Map Link
            </Link>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={clock} alt="Clock icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">ဖွင့်ချိန် မနက် ၉ နာရီ - ပိတ်ချိန် ညနေ ၅ နာရီ</Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Contact Numbers:{" "}
            {mandalayContactNumbers.map((number, index) => (
              <React.Fragment key={number.value}>
                <Link href={`tel:${number.value}`} sx={{ textDecoration: 'none', color: 'inherit' }}>
                  {number.display}
                </Link>
                {index < mandalayContactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Viber:{" "}
            {mandalayViberNumbers.map((number, index) => (
              <React.Fragment key={number.value}>
                <Link href={`viber://chat?number=${number.value}`} sx={{ textDecoration: 'none', color: 'inherit' }}>
                  {number.display}
                </Link>
                {index < mandalayViberNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={email} alt="Email icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link href="mailto:masterrazorblade2023@gmail.com" sx={{ textDecoration: 'none', color: 'inherit' }}>
            masterrazorblade2023@gmail.com
          </Link>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={facebookIcon} alt="Facebook icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link
            href="https://www.facebook.com/share/1N5jqAVVFu/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            facebook.com/share/1N5jqAVVFu
          </Link>
        </Box>
      </Box>
    </section>
  );
}
